import { QueryWrapper } from '@diamond/shared/data-access';
import { BackofficeOrder } from '@diamond/shared/types';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { query } from 'urlcat';

export type ActivityQueryParams = {
  size: number;
  page: number;
  search_by: string;
  search_query: string;
  order_by: string;
  direction: string;
  status: string;
  start_date: number | null;
  end_date: number | null;
  distribution_channel: string;
  do_automation?: 'all' | 'true' | 'false';
  cg_1_business_segmentation: string[];
};

export const useActivities = (queryString: ActivityQueryParams) => {
  const session = useAuthStore();

  const queryActivities = QueryWrapper(
    '/backoffice/order',
    session.access_token
  );

  const {
    data: activitiesData,
    total,
    pageCount,
    refetch,
    isLoading,
    isFetched,
    isFetching,
  } = queryActivities.useQueryGetAll<BackofficeOrder>(
    'Activities',
    queryString,
    undefined,
    undefined,
    {
      paramsSerializer: (p) => {
        return query(p, { arrayFormat: 'repeat' });
      },
    }
  );

  return {
    isLoading,
    isFetching,
    isFetched,
    activitiesData,
    total,
    pageCount,
    refetch,
  };
};
